import {MoodLightCategory} from 'puffco-api-axios-client';
import {useDispatch, useSelector} from 'react-redux';

import {moodlightsApi} from '../api/apis';
import {AsyncWrapperOptions, withAsyncWrapper} from '../api/asyncWrapper';
import {upsertAccountMoodLights} from '../redux/slices/moodLightSlice';
import {userSelector} from '../redux/slices/userSlice';
import {MoodLight} from '../types';
import {useAsyncFn} from './useAsyncFn';

export const useSaveMoodLight = ({
  onSuccess,
  onError,
}: AsyncWrapperOptions<MoodLight>) => {
  const dispatch = useDispatch();
  const user = useSelector(userSelector);

  return useAsyncFn(
    withAsyncWrapper(
      async (
        moodLight: Omit<MoodLight, 'category' | 'format' | 'created'> &
          Partial<Pick<MoodLight, 'category' | 'created'>>,
      ) => {
        if (!user) return;

        const {data} = await moodlightsApi.upsertMoodLight({
          moodLightId: moodLight.id,
          upsertMoodLightDto: {
            name: moodLight.name,
            category: moodLight.category ?? MoodLightCategory.Custom,
            projector: {
              meta: {
                ...moodLight.projector.meta,
                originalMoodLightId:
                  moodLight.projector.meta.originalMoodLightId ?? moodLight.id,
              },
            },
            created: moodLight.created ?? new Date().toISOString(),
            modified: new Date().toISOString(),
          },
        });

        dispatch(upsertAccountMoodLights([data]));

        return data;
      },
      {onSuccess, onError},
    ),
    [user, onSuccess, onError],
  );
};
